import { IconBase, IconComponent } from './BaseIcon';

export const Info: IconComponent = (props) => (
  <IconBase {...props}>
    <path d="M14,8a2,2,0,1,1,2,2A2,2,0,0,1,14,8Zm3,15V12H13v2h2v9H11.5v2h9V23Zm13-7A14,14,0,1,0,16,30,14,14,0,0,0,30,16Zm-2,0A12,12,0,1,1,16,4,12,12,0,0,1,28,16Z" />
  </IconBase>
);
